module.exports = require('../../../content/docs/sidebar.json')
